import {
	mountComponents as doMountComponents,
	getComponentNameByGatewayId,
	findComponentContainer
} from '../util/components';
import { ACTIONS } from './constants';
import { defaultHooks } from "@wordpress/hooks";
import $ from 'jquery';

export const setLongId = ( longId ) => async ( { select, resolveSelect, dispatch } ) => {
	const sdk = await resolveSelect.getSdk()
	await sdk.updateLongId( longId );
	dispatch( { type: ACTIONS.SET_LONG_ID, payload: longId } );
}

export const setSdkState = ( sdkState ) => {
	return { type: ACTIONS.SET_SDK_STATE, payload: sdkState };
};

export function setEnv( env ) {
	return { type: ACTIONS.SET_ENV, payload: env };
}

export const addComponent = ( componentName ) => async ( { select, resolveSelect, dispatch } ) => {
	const sdk = await resolveSelect.getSdk()
	console.log( sdk )
	if ( !sdk.isDroppedIn( componentName ) && typeof findComponentContainer( componentName ) === 'object' ) {
		try {
			const payload = {
				name: componentName,
				component: sdk.dropIn( componentName, {
					hidePaymentButton: true,
				} )
			};
			console.log( 'New component', payload );
			dispatch( { type: ACTIONS.ADD_COMPONENT, payload } );
			doMountComponents( { [ payload.name ]: payload.component }, sdk );
		} catch ( e ) {
			console.error( `Failed to drop in component ${componentName}. Error details: ${e}` );
		}
	}
}

export function removeComponent( componentName ) {
	return { type: ACTIONS.REMOVE_COMPONENT, payload: componentName };
}

/**
 * When a React component is displayed for the first time, the SDK needs to mount its dropIn.
 * So they call this function in a useEffect callback.
 * However:
 * If the SDK has been bootstrapped already, and a new method becomes available after
 * checkout field changes we need to instruct the SDK to refetch the list of dropIn components.
 * This is why we call sdk.updateLongId()
 * After that, the onComponentListChange handler should take care of mounting automatically
 *
 * @returns {(function({select: *, resolveSelect: *, dispatch: *}): Promise<void>)|*}
 */
export const initPayoneerComponents = () => async ( { select, resolveSelect, dispatch } ) => {
	const sdk = await resolveSelect.getSdk()
	const longId = await resolveSelect.getLongId()
	await sdk.updateLongId( longId );
	await dispatch.mountComponents()
}

export const reboot = () => async ( { select, resolveSelect, dispatch } ) => {
	defaultHooks.doAction( 'payoneer.webSdk.reboot' )
	wp.data.dispatch( 'wc/store/cart' ).invalidateResolutionForStore();
	dispatch.invalidateResolutionForStore()
	await dispatch.mountComponents()
}

export const mountComponents = () => async ( { select, resolveSelect, dispatch } ) => {
	const sdk = await resolveSelect.getSdk()
	const availableComponents = select.getAvailableDropInComponents();
	console.log( 'Mounting components', availableComponents );
	doMountComponents( availableComponents, sdk );
};

export const pay = () => ( { select, dispatch } ) => {
	const availableComponents = select.getAvailableDropInComponents();
	const activePaymentMethod = select.getActivePaymentMethod();
	const componentName = getComponentNameByGatewayId( activePaymentMethod );
	const component = availableComponents[ componentName ];
	if ( !component ) {
		console.log( 'Component not found.' );
		return;
	}
	component.pay();
};

export const onBeforeError = ( sdk, component, data ) => async ( { select, dispatch } ) => {
	dispatch.setSdkState( sdk.state );
	console.error( "WebSDK error:", { sdk, component, data } );
	/**
	 * For SYSTEM_FAILURE, we assume there is nothing we can do to recover.
	 * Use hosted mode fallback and let the customer proceed
	 */
	if ( [ "SYSTEM_FAILURE" ].includes( data?.interaction?.reason ) ) {
		dispatch.setForceHostedFlow( true );
		return true;
	}
	/**
	 * Let the outside world attempt to handle the error.
	 * The different checkout types can reboot the payment attempt from there.
	 */
	return defaultHooks.applyFilters( 'payoneer.webSdk.onSdkError', false, sdk, component, data );
}

export const onPaymentDeclined = ( sdk, component, data ) => async ( { select, dispatch } ) => {
	return defaultHooks.applyFilters( 'payoneer.webSdk.onPaymentDeclined', true, sdk, component, data )
}

export const onComponentListChange = ( sdk, changeInfo ) => async ( { select, dispatch } ) => {
	console.log( 'onComponentListChange', sdk, changeInfo );
	changeInfo.addedComponents.forEach( ( name ) => {
		dispatch.addComponent( name );
	} );
	changeInfo.removedComponents.forEach( ( name ) => {
		dispatch.removeComponent( name );
	} );
}
export const onValidationInfo = ( sdk, componentName, data ) => async ( { select, dispatch } ) => {
	console.log(componentName,data)

	dispatch.setIsValid( normalizeComponentName(componentName, data), data.valid );
}

export const setActivePaymentMethod = ( method ) => async ( { dispatch } ) => {
	console.log( 'Setting active payment method', method );
	dispatch.mountComponents()
	dispatch( { type: ACTIONS.SET_ACTIVE_PAYMENT_METHOD, payload: method } );
}

export function setForceHostedFlow( state ) {
	console.log( 'Setting hosted flow override flag', state );
	return { type: ACTIONS.SET_FORCE_HOSTED_FLOW, payload: state };
}

export function setIsValid( componentName, flag ) {
	return { type: ACTIONS.SET_IS_VALID, payload: {componentName: componentName, flag: flag} };
}

export const setOnPaymentDeclinedNonce = ( nonce ) => ( {dispatch} ) => {
	dispatch( { type: ACTIONS.SET_ON_PAYMENT_DECLINED_NONCE, payload: nonce} );
}

export const setOrderId = ( orderId ) => ( {dispatch} ) => {
	dispatch( { type: ACTIONS.SET_ORDER_ID, payload: orderId } );
}

export const releaseOnHoldOrder = (requestData) => async ( { dispatch } ) => {
	const targetUrlBase = window.wc_checkout_params.wc_ajax_url.
	toString().
	replace( '%%endpoint%%', 'payoneer-checkout-payment-declined' );
	const separator = targetUrlBase.includes('?') ? '&' : '?';
	const targetUrl = targetUrlBase +
		separator +
		'_ajax_nonce=' +
		window.PayoneerData.onPaymentDeclinedNonce

	return new Promise( ( resolve, reject ) => {
		$.ajax( {
			type: 'POST',
			url: targetUrl,
			xhrFields: {
				// This is important. We need the session cookie to access the LIST in the back-end
				withCredentials: true,
			},
			data: requestData,
			dataType: 'json',
		} ).success( ( data ) => {
			//New nonce for the next request.
			dispatch.setOnPaymentDeclinedNonce( data.nonce );
			resolve( data );
		} ).catch( ( e ) => {
			console.log( e );
			reject( e )
		} );
	} );
}

function normalizeComponentName(componentName, data) {
	/**
	 * For Stripe Connect merchant, we can get proper payment method name from `data.methodName`
	 * For older merchants, data.methodName doesn't exist, and we need componentName.
	 */
	componentName = data.methodName ?? componentName;

	/**
	 * Also, Stripe Connect uses 'card' instead of 'cards', so we need to fix it.
	 */
	return componentName === 'card' ? 'cards' : componentName;
}
